import { Col, Input, Label, Row, Tooltip } from "reactstrap";
import { Dimensions, Height, Length, WeightKg, Width } from "../../../../../../constants";
import { useState } from "react";
import { useAppDispatch } from "../../../../../../reduxToolkit/hooks";
import { setFormValue } from "../../../../../../reduxToolkit/reducers/eCommerce/addProductSlice";

// This component allows users to input weight and dimensions for a product, with tooltips for guidance.
const WeightDimensionInputs = () => {
  const dispatch = useAppDispatch();
  const [tooltips, setTooltips] = useState({ weight: false, dimensions: false });

  const toggleTooltip = (key: "weight" | "dimensions") => {
    setTooltips((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <>
      <Col xs="12">
        <Row>
          <Col xs="12">
            <Label> {WeightKg} </Label>
            <i className="icon-help-alt ms-1" id="tooltip-weight" />
            <Tooltip target="tooltip-weight" placement="top" toggle={() => toggleTooltip("weight")} isOpen={tooltips.weight}>
              {"set proper weight for product items."}
            </Tooltip>
          </Col>
          <Col xs="12">
            <Input name="inputCity" type="number" onChange={(e) => dispatch(setFormValue({ name: "inputCity", value: e.target.value }))} />
            <p className="f-light"> Decide if the product is a digital or physical item. Shipping may be necessary for real-world items. </p>
          </Col>
        </Row>
      </Col>
      <Col xs="12">
        <Row className="gx-xl-3 gx-md-2 gy-md-0 g-2">
          <Col xs="12">
            <Label>{Dimensions}</Label>
            <i className="icon-help-alt ms-1" id="tooltip-dimensions"></i>
            <Tooltip target="tooltip-dimensions" placement="top" toggle={() => toggleTooltip("dimensions")} isOpen={tooltips.dimensions}>
              {"set proper length/width and height for product items."}
            </Tooltip>
          </Col>
          <Col md="4" sm="6">
            <Input id="inputCity" type="number" placeholder={Length} />
          </Col>
          <Col md="4" sm="6">
            <Input id="inputCity" type="number" placeholder={Width} />
          </Col>
          <Col md="4">
            <Input id="inputCity" type="number" placeholder={Height} />
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default WeightDimensionInputs